import type { UserListItemOut } from "../../../../../api/auth";
import type { Device, DeviceType } from "../../../../../api/devices";

// Акаунт в списъка „Работни точки и потребители" на устройство (POS/фискален).
export interface DeviceAccount {
  id: number;
  name: string;
  // Работна точка (общ акаунт) или личен потребител.
  kind: "workpoints" | "users";
  // Името на ДРУГОТО устройство от същия тип, към което акаунтът вече е
  // закачен — вижда се, но не се избира (един акаунт = едно устройство от тип).
  takenBy: string | null;
}

// Работните точки първи, после потребителите — като в досегашния избирач.
export const buildDeviceAccounts = (
  users: UserListItemOut[],
  devices: Device[],
  deviceType: DeviceType,
  currentDeviceId: number | null,
): DeviceAccount[] => {
  const takenByUserId = new Map<number, string>();
  devices
    .filter((device) => device.type === deviceType && device.id !== currentDeviceId)
    .forEach((device) =>
      device.userIds.forEach((userId) => takenByUserId.set(userId, device.name)),
    );
  const toAccount = (user: UserListItemOut): DeviceAccount => ({
    id: user.id,
    name: user.username,
    kind: user.personal ? "users" : "workpoints",
    takenBy: takenByUserId.get(user.id) ?? null,
  });
  return [
    ...users.filter((user) => !user.personal).map(toAccount),
    ...users.filter((user) => user.personal).map(toAccount),
  ];
};

// Свободните = тези, които не са закачени към друго устройство от типа.
export const freeAccountIds = (accounts: DeviceAccount[]): number[] =>
  accounts.filter((account) => account.takenBy === null).map((account) => account.id);
